import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import FileSaver from 'file-saver';
import { useApi } from 'utils/request/useApi';

type Props = {
  collection: string;
  dataKey: string;
  fileName: string;
};

export const useDownloadCliLog = (props: Props) => {
  const api = useApi();
  const [loading, setLoading] = useLoadingState();

  const downloadLog = () => {
    withLoadingIndicator(setLoading)(async () => {
      const log = await api.request({
        url: `/os/logs/${props.collection}/${props.dataKey}`,
        method: 'GET',
      });
      const blob = new Blob([log], {
        type: 'text/plain;charset=utf-8',
      });
      // !! DO NOT REUSE
      // Downloads should be handled by providing proper headers from backend and initiated using `<a href=""`
      // to use browser's native progress indication and avoid issues with large files.
      FileSaver.saveAs(blob, `${props.fileName}.txt`); // !! DO NOT REUSE
    });
  };

  return {
    loading,
    downloadLog,
  };
};
